import { connect } from 'react-redux';
import DefaultComponent from '../components/index'
import {fetchText, storeText, updateText} from '../actions'

function mapStateToProps(state, ownProps) {
    const { selectedAssessment, selectedActivity, noteText } = state
    const { text } = noteText[ownProps.id] || { text: ''}
    //console.log('noteText')
    //console.log(noteText)
    return {
        assessmentId: selectedAssessment.id,
        activityId: selectedActivity.id,
        text
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {

    return {
        fetchText: (assessmentId, activityId, cpId) => {dispatch(fetchText(assessmentId, activityId, cpId))},
        storeText: (assessmentId, activityId, cpId,text) => { dispatch(storeText(assessmentId, activityId, cpId, text))},
        updateText: (assessmentId, activityId, cpId,text) => {dispatch(updateText(assessmentId, activityId, cpId, text))},
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DefaultComponent)





// WEBPACK FOOTER //
// ./src/modules/notes/containers/index.js